import cancelSvg from 'assets/svg/cancel.svg';

export default () => {
  return (
    <img
      src={cancelSvg}
      alt="split"
      width="22px"
      height="22px"
      style={{ marginRight: 5 }}
    />
  );
};
